import * as React from "react";
import { SideNavigation } from "@awsui/components-react";

const SidebarView = () => {
  const [activeHref, setActiveHref] = React.useState(window.location.pathname);

  return (
    <SideNavigation
      activeHref={activeHref}
      header={{ href: "#/", text: "Services" }}
      onFollow={(event) => {
        // event.preventDefault();
        setActiveHref(event.detail.href);
      }}
      items={[
        {
          type: "section",
          text: "Geospatial Data Labeling",
          items: [
            {
              type: "link",
              text: "Labeling Campaigns",
              href: "/geo-campaigns",
            },
          ],
        },
        {
          type: "section",
          text: "Geospatial Inference",
          items: [
            {
              type: "link",
              text: "Geospatial Inference Endpoints",
              href: "/geo-endpoints",
            },
          ],
        },
      ]}
    />
  );
};
export default SidebarView;
